import React from 'react';
import { Link } from 'react-router-dom';

import {
  Box,
  Button,
  Heading,
  // Stack,
  // Image,
  Text,
  UnorderedList,
  ListItem,
  VStack,
  Link as L,
} from '@chakra-ui/react';
import Footer from './components/Footer';

// const imgUrl = `/images/${process.env.REACT_APP_PROJECT_ID}`;

function Promo() {
  return (
    <Box display={'flex'} flexDirection='column'>
      <Heading m={5} textAlign='center' color='white' fontSize={'4xl'}>
        Segnala un evento e vinci un premio!
      </Heading>
      <Text fontWeight={600}>
        Aiutaci a far conoscere la nostra app agli organizzatori di sagre, fiere e manifestazioni,
        potresti ottenere un premio!
      </Text>
      <br />
      <Text fontWeight={600}>Come funziona? </Text>
      <br />
      <Text>
        Segnala un evento: Se conosci un evento che non utilizza ancora Popular, presentaci agli
        organizzatori: può essere una sagra, una fiera, una festa di paese o qualsiasi evento che
        preveda la gestione di ordini e pagamenti.
      </Text>
      <br />
      <Text>
        Se la segnalazione va a buon fine e l'organizzatore decide di adottare Popular per il suo
        evento, ti ricompenseremo con un premio in denaro di <b>200 euro!</b>
      </Text>
      <br />
      <Text fontWeight={600}>Perché segnalarci un evento?</Text>
      <br />
      <UnorderedList>
        <ListItem>
          <b>Migliora gli eventi locali:</b> con Popular gli organizzatori possono migliorare
          l'esperienza dei partecipanti, riducendo le file alla cassa e le attese.
        </ListItem>
        <br />
        <ListItem>
          <b>Fai parte del cambiamento:</b> aiuta a far crescere una piattaforma che supporta la
          comunità locale e facilita l'organizzazione degli eventi che ami.
        </ListItem>
        <br />
        <ListItem>
          <b>Ottieni un premio esclusivo:</b> come ringraziamento per il tuo contributo, ti
          ricompenseremo ogni volta che una segnalazione si trasforma in una collaborazione!
        </ListItem>
      </UnorderedList>

      <br />

      <VStack spacing={3} align='start'>
        <Text fontWeight={600} fontSize={'2xl'}>
          Contatti
        </Text>
        <Text fontSize={'xl'}>
          <L href='mailto:infinitymundi.publishing@gmail.com' color='gold'>
            infinitymundi.publishing@gmail.com
          </L>
        </Text>
        <Text fontSize={'xl'}>
          <L href='tel:+393384291451' color='gold'>
            3384291451
          </L>
        </Text>
        <Text fontSize={'xl'}>
          <L href='https://popular-pagamenti.web.app/' color='gold'>
            Sito web
          </L>
        </Text>
      </VStack>
      <Button as={Link} to='/' my={50} size={'lg'}>
        Ritorna alla Home
      </Button>
      <Footer />
    </Box>
  );
}

export default Promo;
